import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  private _token:string;
  private _tokenInvalid:boolean;
  private _serverError:boolean;
  public openTermsAndConditions:boolean;
  public termsAndConditionsAgreed:boolean;



  constructor(
    private authService:AuthService
    ,private router:Router
    ,private alertService: AlertService
  ) {
    this.termsAndConditionsAgreed = false;
  }

  ngOnInit() {
  }

  get token() { 
    return this._token;
  }

  set token(v:string) {
    this._token = v;
  }

  handleSubmit(event:KeyboardEvent) {
    if (event && event.charCode === 13) {
      this.login();
    }
  }

  login() {
    if (!this._token || this._token.trim() === "") {
      this.alertService.error("Enter in your client token to continue");
      return;
    }
    // if (!this.termsAndConditionsAgreed) {
    //   this.alertService.error("You must agree to the terms and conditions before continuing.");
    //   return;                                                                                                           
    // }

    this.authService.authenticateClient(this._token)
    .then((clientId) => {
        this.router.navigate(["/assessments/dashboard"]);
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error(error.message);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login/login.component.ts